(function () {

function render_fin_filters (root_el) {
  const fin_filters_el = document.createElement('div');
  fin_filters_el.className = 'fin_filters';
  root_el.appendChild(fin_filters_el);

  {
    const filter_el = document.createElement('a');
    filter_el.href = window_api_data.root_url + '/collections/fins-twin';
    filter_el.className = 'filter';
    fin_filters_el.appendChild(filter_el);
    
    const img = document.createElement('img');
    img.src = window_api_data.fin_images.twin;
    img.alt = 'Twin';
    img.className = 'image';
    img.draggable = false;
    filter_el.appendChild(img);
    
    const text = document.createElement('div');
    text.innerText = 'Twin';
    text.className = 'text'; 
    filter_el.appendChild(text);
  }

  {
    const filter_el = document.createElement('a');
    filter_el.href = window_api_data.root_url + '/collections/fins-thruster-quad';
    filter_el.className = 'filter';
    fin_filters_el.appendChild(filter_el);
    
    const img = document.createElement('img');
    img.src = window_api_data.fin_images.thruster;
    img.alt = 'Thruster & Quad';
    img.className = 'image'; 
    filter_el.appendChild(img);
    
    const text = document.createElement('div');
    text.innerText = 'Thruster & Quad';
    text.className = 'text'; 
    filter_el.appendChild(text);
  }

  {
    const filter_el = document.createElement('a');
    filter_el.href = window_api_data.root_url + '/collections/fins-single';
    filter_el.className = 'filter';
    fin_filters_el.appendChild(filter_el);
    
    const img = document.createElement('img');
    img.src = window_api_data.fin_images.single;
    img.alt = 'Single';
    img.className = 'image';
    img.draggable = false;
    filter_el.appendChild(img);
    
    const text = document.createElement('div');
    text.innerText = 'Single';
    text.className = 'text'; 
    filter_el.appendChild(text);
  }

  {
    const filter_el = document.createElement('a');
    filter_el.href = window_api_data.root_url + '/collections/fins-all';
    filter_el.className = 'filter';
    fin_filters_el.appendChild(filter_el);
    
    const img = document.createElement('img');
    img.src = window_api_data.fin_images.allfins;
    img.alt = 'All';
    img.className = 'image';
    img.draggable = false;
    filter_el.appendChild(img);
    
    const text = document.createElement('div');
    text.innerText = 'All';
    text.className = 'text'; 
    filter_el.appendChild(text);
  }
}


function render_fin_card (root_el, product, variant, color) {
  const fin_card_el = document.createElement('a');
  fin_card_el.href = window_api_data.root_url + product.url+(variant ? ('?variant='+variant.id) : '');
  fin_card_el.className = 'fin_card';
  fin_card_el.product_title = product.title;
  root_el.appendChild(fin_card_el);

  const img_el = document.createElement('img');
  img_el.className = 'img';
  if (variant) {
    img_el.src = variant.featured_image.src;
  }
  else {
    img_el.src = product.images[0];
  }
  fin_card_el.appendChild(img_el);

  const title_el = document.createElement('div');
  title_el.className = 'title h6';
  if (color) {
    title_el.innerText = product.title + ' - ' + color;
    if (product.url == '/products/keel-fins') {
      title_el.innerText = product.title + ' - ' + variant.title.replace('/', '-'); // keels show variant size and color
    }
  }
  else {
    title_el.innerText = product.title;
  }
  fin_card_el.appendChild(title_el);

  const price = ((variant ? variant.price : product.price) / 100).toFixed(2);
  const price_el = document.createElement('div');
  price_el.className = 'price h6';
  price_el.innerText = window_api_data.currency_symbol + price;
  fin_card_el.appendChild(price_el);

}


function render_all_product_cards () {
  const root_el = document.getElementsByTagName('product-list')[0];
  root_el.innerHTML = '';

  for (let i=0; i<window_api_data.products_fins.length; i++) {
    const product = window_api_data.products_fins[i];

    const index = product.options.indexOf('Color');
    if (index == -1) {
      render_fin_card(root_el, product, null);
      continue;
    }

    const found_colors = [];
    const key = 'option' + (index + 1)
    for (let j=0; j<product.variants.length; j++) {
      const variant = product.variants[j];
      const color = variant[key];
      if (found_colors.indexOf(color) != -1) {
        continue;
      }
      if (product.url != '/products/keel-fins') { // show all keel fins
        found_colors.push(color);
      }
      render_fin_card(root_el, product, variant, color);
    }
  }
}


function render_fins (root_el) {
  var show_fins = ['Fins - Twin', 'Fins - Thruster & Quad', 'Fins - Single', 'Fins - All']
  if (show_fins.includes(window_api_data.collection_title)) {
    render_all_product_cards();
  } else if (window_api_data.collection_title == 'Fins') {
    render_fin_filters(root_el);
  }
}

window.render_fins = render_fins;


})();
